import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import CircularProgress from '@material-ui/core/CircularProgress'

import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@material-ui/icons/Cancel'

export default function AddCategoryDialog (props) {
  const [newCategory, setNewCategory] = React.useState('')
  const [error, setError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const [saving, setSaving] = React.useState(false)

  const categoryTextFieldRef = React.useRef()

  const handleAddCategoryClick = async () => {
    if (saving) {
      return // stop multiple add presses
    }

    // validate the category name before submission
    const regex = new RegExp(/^[a-zA-Z0-9-\s]{2,100}$/)

    if (regex.test(newCategory)) {
      setSaving(true)
      await props.onSave(newCategory)

      setNewCategory('')
      setSaving(false)
    } else {
      setError(true)
      setErrorMessage('Category name must be at between 2 and 100 characters long')
    }
  }

  const handleNewCategoryChange = (event) => {
    setError(false)
    setErrorMessage('')

    setNewCategory(event.target.value)
  }

  const handleClose = (event, reason) => {
    // don't close by clicking background
    if (reason === 'backdropClick') {
      return
    }

    if (saving) {
      return
    }

    props.onClose(event, reason)
    setNewCategory('')
  }

  const handleOnEntered = () => {
    categoryTextFieldRef.current.focus()
  }

  return (
    <Dialog maxWidth="sm" fullWidth={true} onClose={handleClose} open={props.open} TransitionProps={{ onEntered: handleOnEntered }}>
      <DialogTitle>
        Add New Category
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          margin="dense"
          label="Category Parent"
          type="text"
          InputProps={{
            readOnly: true
          }}
          fullWidth
          defaultValue={props.parentCategory} />
        <TextField
          id='newCategoryName'
          inputRef={categoryTextFieldRef}
          margin="dense"
          label="New Category Name"
          type="text"
          error={error}
          helperText={errorMessage}
          fullWidth
          value={newCategory}
          onChange={handleNewCategoryChange}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={handleAddCategoryClick} color="primary">
          {
            saving === true
              ? <><CircularProgress color="inherit" size={20} />&nbsp;</>
              : <><SaveIcon />&nbsp;</>
          }
          Add
        </Button>
        <Button variant="contained" onClick={handleClose} color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>)
}

AddCategoryDialog.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  parentCategory: PropTypes.string.isRequired
}
